import { defineComponent as _defineComponent } from 'vue'
import { Button, Icon, Modal, Picture, Typo } from '@travelata-libs/ui-kit';
  import { useViewport } from '@travelata-libs/utils';
  import { OperatorId } from '@entities/operator';
  import { PROVIDERS_MODAL_Z_INDEX } from '../config';
  import { getProviderLogo } from '../lib/getProviderLogo';
  import { type ProviderOfferData } from '../model/types';

  interface PartnerRedirectModalProps {
    offer: ProviderOfferData;
  }

  interface PartnerRedirectModalEmits {
    (e: 'close'): void;
    (e: 'confirm'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerRedirectModal',
  props: {
    offer: null
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'close'): void;
    (e: 'confirm'): void;
  }), expose: any, slots: any, attrs: any }) {

  
  

  const { isMobile } = useViewport();

  const travelataLogoId = OperatorId.Travelata[0];

  const onConfirm = (): void => {
    window.Intercom?.('hide');
    document.querySelector('.js-intercom-loading-stub')?.remove();
    emit('confirm');
  };

return { __sfc: true,emit, isMobile, travelataLogoId, onConfirm, Button, Icon, Modal, Picture, Typo, PROVIDERS_MODAL_Z_INDEX, getProviderLogo }
}

})